const BLOG_STANDALONE_QUERY_KEYS = [
  'perPage',
  'pageNumb',
  'search',
  'tag',
  'blog_perPage',
  'blog_pageNumb',
  'blog_per_page',
  'blog_page_number',
  'blog_page_numb',
  'blog_search',
  'blog_tag',
];

const BLOG_EMBED_QUERY_KEYS = [
  'blog_perPage',
  'blog_pageNumb',
  'blog_per_page',
  'blog_page_number',
  'blog_page_numb',
  'blog_search',
  'blog_tag',
];

const decodeQueryValue = (value) => {
  const raw = Array.isArray(value) ? value[0] : value;
  if (raw === undefined || raw === null || raw === '') return '';
  const text = String(raw);
  try {
    return decodeURIComponent(text);
  } catch {
    return text;
  }
};

const readQueryInt = (query, keys, fallback) => {
  for (const key of keys) {
    if (key in query && query[key] !== '' && query[key] != null) {
      const parsed = parseInt(query[key], 10);
      if (!Number.isNaN(parsed)) return parsed;
    }
  }
  return fallback;
};

export const parseBlogParamsFromQuery = (query, defaultPerPage = 9, { embed = false } = {}) => {
  const q = query || {};
  const perPage = readQueryInt(
    q,
    ['blog_per_page', 'blog_perPage', 'perPage'],
    defaultPerPage,
  );
  const pageNumb = readQueryInt(
    q,
    ['blog_page_number', 'blog_page_numb', 'blog_pageNumb', 'pageNumb'],
    1,
  );

  let search = '';
  if (embed) {
    if ('search' in q) search = decodeQueryValue(q.search);
    else if ('blog_search' in q) search = decodeQueryValue(q.blog_search);
  } else if ('blog_search' in q) {
    search = decodeQueryValue(q.blog_search);
  } else if ('search' in q) {
    search = decodeQueryValue(q.search);
  }

  let tag = '';
  if ('blog_tag' in q) tag = decodeQueryValue(q.blog_tag);
  else if ('tag' in q) tag = decodeQueryValue(q.tag);

  return {
    perPage: perPage || defaultPerPage,
    pageNumb: pageNumb || 1,
    search,
    tag,
  };
};

export const buildBlogRouteQuery = (
  query,
  {
    perPage,
    pageNumb,
    search,
    tag,
    embed = false,
    defaultPerPage = 9,
  } = {},
) => {
  const nextQuery = { ...(query || {}) };
  const keysToRemove = embed ? BLOG_EMBED_QUERY_KEYS : BLOG_STANDALONE_QUERY_KEYS;

  keysToRemove.forEach((key) => {
    delete nextQuery[key];
  });

  if (perPage !== undefined && Number(perPage) !== Number(defaultPerPage)) {
    nextQuery.blog_per_page = String(perPage);
  }
  if (pageNumb !== undefined && pageNumb > 1) {
    nextQuery.blog_page_number = String(pageNumb);
  }

  if (!embed) {
    if (search !== undefined && search) {
      nextQuery.blog_search = search;
    }
  }

  if (tag !== undefined && tag) {
    nextQuery.blog_tag = tag;
  }

  return nextQuery;
};

export const queriesAreEqual = (a = {}, b = {}) => {
  const keysA = Object.keys(a).sort();
  const keysB = Object.keys(b).sort();
  if (keysA.length !== keysB.length) return false;
  return keysA.every((key) => String(a[key] ?? '') === String(b[key] ?? ''));
};
